import TableList from "@components/templates/tablelist";
import { HttpMarkChangeOrderOutList, HttpMarkChangeOrderOutConfirm, HttpMarkChangeOrderOutCancel } from "@/service/misc";
import { mapState, mapGetters } from "vuex";
import comIndex from './update'
import comIndexPlan from '../markchangecustom/update.vue'
import compAdd from './add.vue'
import mixin from '../mixin';

export default {
    mixins: [ TableList, mixin],
    components: {
        compAdd,
        comIndex,
        comIndexPlan,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    'quanbu': 0,
                },
            },
            exportdata:{},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpMarkChangeOrderOutList,
        handleParams (params) {
            if (params.search.quanbu === 0) {
                params.search.EQ_status = null
            }
            else if (params.search.caogao === 0) {
                params.search.EQ_status = 0
            }
            else if (params.search.yiqueren === 0) {
                params.search.EQ_status = 70
            }
            else if (params.search.yiquxiao === 0) {
                params.search.EQ_status = 90
            }
            delete params.search.quanbu
            delete params.search.caogao
            delete params.search.yiqueren
            delete params.search.yiquxiao
            this.exportdata = params
            return params
        },
        interceptRequest(params) {
            return this.handleParams(params)
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.operate = {
                        show: true,
                        title: this.$t('global.common.operation_add', { defaultValue: "添加" }),
                        width: 'large',
                        showFooter: false,
                        component: "compAdd",
                    };
                    break;
                case "edit":
                    this.$router.push({
                        name: 'markChangeOrderOutDetail',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        alertbox: true,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "markChangeOrderOutDetail",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "queryPlan":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comIndexPlan",
                        activeid: params,
                        alertbox: true,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "confirm":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.datepicker.confirm', { defaultValue: "确认" }),
                        width: 460,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "Textarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                            }
                        ],
                        ajaxRequest: HttpMarkChangeOrderOutConfirm,
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                        width: 460,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "Textarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                            }
                        ],
                        ajaxRequest: HttpMarkChangeOrderOutCancel,
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/changeLabelOutbound/exportByManage",
                    this.exportdata, {
                        executor: 'request',
                        download: true,
                    }).catch(err => {
                        this.$VMessage.error(err.message);
                    })
                    break
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                    show: status == 0,
                    params: id,
                    operate: 'edit'
                },
                {
                    label: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
                    show: status == 0,
                    params: id,
                    operate: 'confirm'
                },
                {
                    label: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                    show: status == 0,
                    params: id,
                    operate: 'cancel'
                },
            ]
        },
    },
    computed: {
        ...mapGetters( 'dictionary', [ 'getCusproductList']),
        TabsData() {
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: '全部' }),
                    key: 'quanbu',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.draft', { defaultValue: '草稿' }),
                    key: 'caogao',
                    val: 0,
                },
                {
                    name: this.$t('', { defaultValue: "已确认" }),
                    key: 'yiqueren',
                    val: 0
                },
                {
                    name: this.$t('', { defaultValue: "已取消" }),
                    key: 'yiquxiao',
                    val: 0
                },
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'export',
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: this.$t('', { defaultValue: "换标下架单号" }),
                    tag: 'Input',
                    key: 'EQ_changeLabelOrderNo',
                    show: true,
                    style: 'width: 150px;'
                },
                {
                    label: this.$t('', { defaultValue: "换标上架计划单号" }),
                    tag: 'Input',
                    key: 'EQ_changeLabelPlanNo',
                    show: true,
                    style: 'width: 150px;'
                },
                {
                    label: "项目",
                    tag: 'Select',
                    key: 'EQ_lineId]',
                    options:this.getCusproductList,
                    props:{
                        filterable:true
                    },
                    show:true,
                    style: 'width: 150px;'
                },
                {
                    label: "单据状态",
                    tag: 'Select',
                    key: 'IN_status',
                    options: this.getBillStatus2,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: widthStyle
                },
                // {
                //     label: "库存类型",
                //     tag: "Select",
                //     key: "EQ_inventoryType",
                //     options: [
                //         { value: 0, label: "可售库存" },
                //         { value: 1, label: "不可售库存" },
                //     ],
                //     props: {
                //         filterable: true,
                //     },
                //     style: widthStyle
                // },
                {
                    label: "来源单号",
                    tag: 'Input',
                    key: 'EQ_sourceNo',
                    style: widthStyle
                },
                {
                    label: '创建日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id',
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                },
                {
                    title: "换标下架单号",
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.changeLabelOrderNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                    }
                },
                {
                    title: "换标上架计划单号",
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.changeLabelPlanId, 'queryPlan')}>{row.changeLabelPlanNo || '--'}</a>
                                {/* <a onClick={this.handleOperates.bind(this, row.changeLabelPlanId, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a> */}
                            </div>
                        </div>
                    }
                },
                {
                    title: "来源单号",
                    render: (h, { row }) => {
                        return <div>
                            { row.sourceNo || '--'}
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.alloment.order_status', { defaultValue: "单据状态" }),
                    width: 90,
                    render: (h, { row }) => {
                        const status = row.status;
                        const { theme = 'default', label } = this.getBillStatus2.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{status ? label : this.$t('fbb.inbound.draft', { defaultValue: '草稿' })}</vButton>
                    }
                },
                {
                    title: "项目/库存类型",
                    render: (h, { row }) => {
                        return <div>
                            <div>{this.findRenderLabel(this.getCusproductList, row.lineId) || '--'}</div>
                            <div>{row.inventoryType == 0 ? '可售库存':'不可售库存' || '--'}</div>
                        </div>
                    },
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    width: 180,
                },
            ];
        },

    },
}
